/**
 * Client-side image resize for listing photo upload (main + thumbnail).
 * Matches pattern used in HuntLogPage for harvest photos.
 */
const MAIN_MAX_SIZE = 1600;
const THUMB_MAX_SIZE = 320;

export function downscaleImage(file, maxSize) {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        const ratio = width / height;
        if (width > height) {
          if (width > maxSize) {
            height = Math.round(maxSize / ratio);
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width = Math.round(maxSize * ratio);
            height = maxSize;
          }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(objectUrl);
            if (!blob) {
              reject(new Error('Image compression failed'));
              return;
            }
            resolve({ blob, width, height });
          },
          'image/jpeg',
          0.8
        );
      } catch (err) {
        URL.revokeObjectURL(objectUrl);
        reject(err);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to load image'));
    };
    img.src = objectUrl;
  });
}

export function buildThumbnail(file) {
  return downscaleImage(file, THUMB_MAX_SIZE);
}

export function buildMainImage(file) {
  return downscaleImage(file, MAIN_MAX_SIZE);
}
